import React from "react";
import { Card } from "@mantine/core";

const DocsHighlightCard = ({ children, ...props }) => (
  <Card padding="sm" radius="md" withBorder mb="20px" {...props}>
    {children}
  </Card>
);

export default DocsHighlightCard;
